import request from 'local_modules/request'
import actions from 'redux/actions'
import { constants, modals, links } from 'helpers'
import { reducers, getState } from 'redux/core'


const login = ({ login, password, pass: _pass }) => {
  const url   = `${constants.smartSarov.auth}${Math.random() * 1000}`
  const pass  = _pass || password

  const body = new FormData()
  body.set('json', JSON.stringify({ login, pass }).replace('/', ''))

  actions.cookies.removeItem('redirectUrl')

  return request({
    method: 'post',
    url,
    data: body,
    config: {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  })
    .then(({ data }) => data)
    .then((data) => {
      console.log({ data })

      const { userId, userMode } = data

      const isCashier   = Number(userMode) === 1
      const isLoggedOff = Number(userId) === -1

      if (isLoggedOff) {
        actions.cookies.removeItem('userName')
        actions.cookies.removeItem('auth')
      }
      else if (isCashier) {
        actions.cookies.setItem('redirectUrl', links.marketplace.login)
        actions.cookies.setItem('auth', pass)
        // update userName cookie
        actions.cookies.setItem('userName', login)
        window.location.replace('/marketplace/edu/food')
      }
    })
}

const fetch = () => {
  window.location.replace('/marketplace')

  return Promise.resolve()
  // return Promise.all([
  //   getLayers(request),
  //   getUserData(request),
  //   getAccessLevel(request),
  //   getEduCashierAccessLevel(request),
  // ])
  //   .then(([ layers, userData, accessLevel, cashierAccessLevel ]) => {
  //     const { userId, userMode, username = null, email = null, ico = null } = userData
  //
  //     console.log('Fetching done', {
  //       id: userId,
  //       email,
  //       layers,
  //       userMode,
  //       username,
  //       avatar: ico,
  //       isLoggedIn: userId !== -1,
  //
  //       // isAdmin: userMode === 1 && accessLevel === 2,
  //       // isCashier: userMode === 1 && accessLevel === 1,
  //       // isCustomer: userMode !== 1,
  //     })
  //
  //     actions.marketplace.accessLevel.set({
  //       ...accessLevel,
  //       edu: {
  //         ...(accessLevel.edu || {}),
  //         cashierAccessLevel
  //       },
  //     })
  //
  //     reducers.me.set({
  //       id: userId,
  //       email,
  //       layers,
  //       userMode,
  //       username,
  //       avatar: ico,
  //       isLoggedIn: userId !== -1,
  //
  //       // isAdmin: userMode === 1 && accessLevel === 2,
  //       // isCashier: userMode === 1 && accessLevel === 1,
  //       // isCustomer: userMode !== 1,
  //     })
  //   })
}

const reset = reducers.me.reset

const set = reducers.me.set

const setCashier = (isCashier) => {
  reducers.me.update({ isCashier, isCustomer: !isCashier })
}

const exit = () => {
  const { me: { id } } = getState()

  actions.cookies.removeItem('redirectUrl')
  // actions.cookies.removeItem('userName')
  actions.cookies.removeItem('auth')

  actions.cookies.removeItem('userId')
  actions.cookies.removeItem(`cook${id}`)

  try {
    window.localStorage.clear()
  }
  catch (error) {
  }

  return fetch()
}

const openFeedbackModal = () => {
  const { me: { email } } = getState()

  actions.modals.open(modals.DialogWithForm, {
    title: `Техподдержка`,
    text: 'Если Вам необходима помощь в работе с сервисом, Вы нашли ошибку или у Вас есть предложения по его улучшению',
    bottomText: `Нажимая кнопку "Отправить", я соглашаюсь с <a href="${constants.smartSarov.terms}" target="_blank">условиями участия</a> и даю согласие на <a href="${constants.smartSarov.terms}" target="_blank">обработку персональных данных</a>`,
    buttonTitle: 'Отправить',
    columns: 1,
    fields: [
      {
        fieldType: 'textArea',
        fieldName: 'message',
        placeholder: 'Введите текст Вашего запроса (по вопросам оплаты школьного питания обязательно указывайте ФИО ученика, номер школы, класс)',
        label: 'Введите текст Вашего запроса',
        size: 1,
      },
      {
        fieldType: 'input',
        fieldName: 'email',
        placeholder: 'Укажите Ваш e-mail',
        label: 'Укажите Ваш e-mail',
        value: email,
        size: 1,
      },
    ],
    onSubmit: ({ email, message }) => {
      sendFeedback({ email, message })
        .then(() => {
          actions.modals.open(modals.Dialog, {
            title: 'Сотрудник нашей службы ответит Вам в ближайшее время',
          })
        })
    },
  })
}

const sendFeedback = ({ email, message }) => {
  const {
    me: { id },
    // marketplace: {
    //   layersNavigation: {
    //     category,
    //   },
    // },
  } = getState()

  const userAgent = window && window.navigator && window.navigator.userAgent

  let _message = message

  _message += `\n\nСтраница запроса: ${window.location.origin + window.location.pathname + window.location.search}`

  if (id) {
    _message += `\n\nID пользователя: ${id}`
  }

  if (userAgent) {
    _message += `\n\nUserAgent: ${userAgent}`
  }

  return request.post(constants.edu.feedback, {
    email,
    message: _message,
  })
}


export default {
  fetch,
  login,
  set,
  reset,
  exit,
  setCashier,
  sendFeedback,
  openFeedbackModal,
}
